import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackAnnotationColorChanged } from "@air/analytics";
import { pink, purple, red, teal, yellow } from "@air/colors";
import { Checkbox } from "@air/primitive-checkbox";
import classNames from "classnames";
import { memo } from "react";
import { ANNOTATION_COLOR_CHECKBOX } from "~/constants/testIDs";
export const ANNOTATION_COLORS = [
    {
        className: "bg-pink-5 radix-state-checked:bg-pink-5",
        id: "pink-5",
        hex: pink.pink5
    },
    {
        className: "bg-purple-8 radix-state-checked:bg-purple-8",
        id: "purple-8",
        hex: purple.purple8
    },
    {
        className: "bg-teal-7 radix-state-checked:bg-peacock-400",
        id: "teal-7",
        hex: teal.teal7
    },
    {
        className: "bg-yellow-5 radix-state-checked:bg-yellow-5",
        id: "yellow-5",
        hex: yellow.yellow5
    },
    {
        className: "bg-red-8 radix-state-checked:bg-red-8",
        id: "red-8",
        hex: red.red8
    }
];
export const AnnotationColorSelect = /*#__PURE__*/ memo((param)=>{
    let { selectedColor, setColor } = param;
    const { trackAnnotationColorChanged } = useTrackAnnotationColorChanged();
    return /*#__PURE__*/ _jsx("div", {
        className: "mr-1 flex items-center gap-1 py-2",
        children: ANNOTATION_COLORS.map((color)=>/*#__PURE__*/ _jsx(Checkbox, {
                "aria-label": "Annotate using ".concat(color.id, " color"),
                checked: selectedColor === color.hex,
                className: classNames("border-none", color.className),
                "data-color": color,
                "data-testid": "".concat(ANNOTATION_COLOR_CHECKBOX, "-").concat(color),
                onCheckedChange: ()=>{
                    trackAnnotationColorChanged({
                        color: color.id
                    });
                    setColor(color.hex);
                },
                size: "extra-large"
            }, color.id))
    });
});
AnnotationColorSelect.displayName = "AnnotationColorSelect";
